import React, { useEffect, useState } from 'react';
import DataService from "../../../services/data.service";
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { ItemTypeIdProps } from '../../../types/IdProps';
import AddItemTypeWorkflowDefinitionPopup from '../Popups/ItemType_popup_AddWorkflowDefinition';

const ItemType_tab_WorkflowDefinitions: React.FC<ItemTypeIdProps> = ({ itemTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/WorkflowDefinitions/ByItemType/' + itemTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowDefinitions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditItemType, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemTypeWorkflows'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Workflow definition'
                navigateUrl='/plm/workflowsetup/workflow/'
            />
            {showPopup && <AddItemTypeWorkflowDefinitionPopup itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemType_tab_WorkflowDefinitions;